import { createFileRoute } from "@tanstack/react-router";
import { type TimelineFilter, TimelineScreen } from "../../screens/timeline/TimelineScreen.tsx";

const FILTERS: TimelineFilter[] = ["all", "release", "business", "calendar"];

/** `/timeline`: what happened to the business, a tab of Insights. The filter rides in the link. */
export const Route = createFileRoute("/_app/timeline")({
  validateSearch: (s: Record<string, unknown>): { show?: TimelineFilter } =>
    FILTERS.includes(s.show as TimelineFilter) && s.show !== "all" ? { show: s.show as TimelineFilter } : {},
  component: TimelineScreen,
});
